import { render } from "./AutomaticReportDetail.vue?vue&type=template&id=f885ead6"
import script from "./AutomaticReportDetail.vue?vue&type=script&lang=js"
export * from "./AutomaticReportDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QStepper from 'quasar/src/components/stepper/QStepper.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QStep from 'quasar/src/components/stepper/QStep.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QStepperNavigation from 'quasar/src/components/stepper/QStepperNavigation.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QStepper,QForm,QStep,QSelect,QCheckbox,QRadio,QItem,QItemSection,QIcon,QTooltip,QStepperNavigation,QBtn,QInput,QDialog,QCard});
